"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./AreasItemCounter.scss");

require("./AreasItemCounterDark.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var AreasItemCounter = function AreasItemCounter(_ref) {
  var type = _ref.type,
      icon = _ref.icon,
      title = _ref.title,
      counter = _ref.counter;
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-counter-item"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-counter-item-wraper"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-counter-item-head"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: 'gcl-areas-counter-item-icon ' + type
  }, icon)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-counter-item-body"
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-title-areas"
  }, title)), /*#__PURE__*/_react["default"].createElement("div", {
    className: "gcl-areas-counter-item-counter"
  }, counter)));
};

AreasItemCounter.propTypes = {
  type: _propTypes["default"].oneOf(['msn', 'email', 'twitter']),
  icon: _propTypes["default"].string,
  title: _propTypes["default"].string,
  counter: _propTypes["default"].string
};
var _default = AreasItemCounter;
exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/global-components-library/dist/components/AreasItem/AreasItemCounter.js
// module id = 1885
// module chunks = 0